import PropTypes from 'prop-types';

export const slidePropTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  isHidden: PropTypes.bool,
  isScrollAllowed: PropTypes.bool,
  minWidth: PropTypes.number,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
  width: PropTypes.number,
};

export const slideDefaultProps = {
  isActive: false,
  isHidden: false,
  isScrollAllowed: false,
  minWidth: undefined,
  onClick: undefined,
  onFocus: undefined,
  onMouseDown: undefined,
  onMouseUp: undefined,
  onTouchStart: undefined,
  onTouchEnd: undefined,
  width: undefined,
};

export const sliderPropTypes = {
  label: PropTypes.string.isRequired,
  minimumSlideWidth: PropTypes.number,
  nextLabel: PropTypes.string,
  onSlideChange: PropTypes.func,
  onSlideClick: PropTypes.func,
  previousLabel: PropTypes.string,
  slides: PropTypes.arrayOf(PropTypes.node).isRequired,
  slidesToShow: PropTypes.number,
  sliderControlOffset: PropTypes.number,
  isInfinite: PropTypes.bool,
  showControls: PropTypes.bool,
  description: PropTypes.string,
  leftControlClassName: PropTypes.string,
  rightControlClassName: PropTypes.string,
  currentIndex: PropTypes.number,
};

export const sliderDefaultProps = {
  minimumSlideWidth: undefined,
  nextLabel: undefined,
  onSlideChange: undefined,
  onSlideClick: undefined,
  previousLabel: undefined,
  slidesToShow: undefined,
  sliderControlOffset: undefined,
  isInfinite: false,
  showControls: true,
  description: 'carousel',
  leftControlClassName: '',
  rightControlClassName: '',
  currentIndex: undefined,
};
